/* ============
 * Product Groups Index
 * ============
 *
 * This page shows the list of product groups.
 */

import { mapGetters, mapMutations } from 'vuex';
import accountService from './../../../../services/account';
import productGroupService from './../../../../services/product-group';
import SearchMixin from './../../../../mixins/search';
import debounce from 'debounce';

export default {
  data() {
    return {
      loading: false,
      sort: '',
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      productGroups: 'paginatedProductGroups',
      account: 'account',
    }),
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },

  mounted() {
    let productFilter = {
      title: this.$t('static.products.filters.title'),
      options: [{
        title: this.$t('static.products.filters.withDeposit'),
        route: {
          name: 'products.index',
          query: {
            filter: 'withDeposit',
          },
        },
      },
      {
        title: this.$t('static.products.filters.deactivated'),
        route: {
          name: 'products.index',
          query: {
            filter: 'deactivated',
          },
        },
      },
      {
        title: this.$t('static.products.filters.materials'),
        route: {
          name: 'products.index',
          query: {
            type: 'Material',
          },
        },
      },
      {
        title: this.$t('static.products.filters.all'),
        route: {
          name: 'products.index',
        },
      },
      ],
      button: {
        title: `+ ${this.$t('static.products.create.title')}`,
        route: {
          name: 'products.create',
        },
      },
    };
    const productBundle = {
      title: this.$t('static.productBundles.filters.title'),
      options: [{
        title: this.$t('static.productBundles.filters.all'),
        route: {
          name: 'productBundles.index',
        },
      }],
      button: {
        title: `+ ${this.$t('static.productBundles.create.title')}`,
        route: {
          name: 'productBundles.create',
        },
      },
    };
    let vmpSyncMenu = {};
    if (this.account.modules.length > 0) {
      for (let i = 0; i < this.account.modules.length; i++) {
        if (this.account.modules[i].name == 'EDI') {
          productFilter = {
            title: this.$t('static.products.filters.title'),
            options: [{
              title: this.$t('static.products.filters.active'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'active',
                },
              },
            },
            {
              title: this.$t('static.products.filters.deactivated'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'deactivated',
                },
              },
            },
            {
              title: this.$t('static.products.filters.withDeposit'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'withDeposit',
                },
              },
            },
            {
              title: this.$t('static.products.filters.materials'),
              route: {
                name: 'products.index',
                query: {
                  type: 'Material',
                },
              },
            },
            {
              title: this.$t('static.products.filters.asko'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'asko',
                },
              },
            },
            {
              title: this.$t('static.products.filters.vinhuset'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'vinhuset',
                },
              },
            },
            {
              title: this.$t('static.products.filters.marketplace'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'marketplace',
                },
              },
            },
            {
              title: this.$t('static.products.filters.onlineStore'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'onlineStore',
                },
              },
            },
            {
              title: this.$t('static.products.filters.alcohol'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'alcohol',
                },
              },
            },
            {
              title: this.$t('static.products.filters.alcoholFree'),
              route: {
                name: 'products.index',
                query: {
                  filter: 'alcoholFree',
                },
              },
            },
            {
              title: this.$t('static.products.filters.all'),
              route: {
                name: 'products.index',
              },
            },
            ],
            button: {
              title: `+ ${this.$t('static.products.create.title')}`,
              route: {
                name: 'products.create',
              },
            },
          };
        }
        if (this.account.modules[i].name == 'Vinmonopolet') {
          vmpSyncMenu = {
            title: this.$t('static.products.syncVmp.title'),
            button: {
              title: `+ ${this.$t('static.products.syncVmp.title')}`,
              route: {
                name: 'products.syncVmp',
              },
            },
          };
        }
      }
    }

    this.setInnerSidebar([
      productFilter,
      productBundle,
      vmpSyncMenu,
      {
        title: this.$t('static.productPackagings.filters.title'),
        options: [{
          title: this.$t('static.productPackagings.filters.all'),
          route: {
            name: 'productPackagings.index',
          },
        }],
        button: {
          title: `+ ${this.$t('static.productPackagings.create.title')}`,
          route: {
            name: 'productPackagings.create',
          },
        },
      },
      {
        title: this.$t('static.productGroups.filters.title'),
        options: [{
          title: this.$t('static.productGroups.filters.all'),
          route: {
            name: 'productGroups.index',
          },
        }],
        button: {
          title: `+ ${this.$t('static.productGroups.create.title')}`,
          route: {
            name: 'productGroups.create',
          },
        },
      },
      {
        title: this.$t('static.productTags.filters.title'),
        options: [{
          title: this.$t('static.productTags.filters.all'),
          route: {
            name: 'productTags.index',
          },
        }],
        button: {
          title: `+ ${this.$t('static.productTags.create.title')}`,
          route: {
            name: 'productTags.create',
          },
        },
      },

      {
        title: this.$t('static.exciseEntry.title'),
        options: [{
          title: this.$t('static.exciseEntry.filters.all'),
          route: {
            name: 'exciseentry.index',
          },
        }],
      },
    ]);

    accountService.rememberPerPage('get', { from: 'product_group' })
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, this.limit);
    },
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'product_group', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Fetches paginated product groups.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed per page.
     */
    all: debounce(function (page, limit = 10) {
      this.loading = true;
      productGroupService.items({
        page,
        limit,
        search: this.getSearch(this.limit),
        filter: this.$route.query.filter,
      })
        .then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
    }, 800),

    /**
     * Delete specific product group.
     *
     * @param  {Object} productGroup The product group object.
     */
    deleteProductGroup(productGroup) {
      this.$confirm(this.$t('static.productGroups.index.confirmDelete'), this.$t('static.productGroups.index.confirmDeleteTitle'), {
        confirmButtonText: this.$t('button.delete'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        productGroupService.destroy(productGroup.id)
          .catch(({ response }) => {
            const message = response.data.error.code === 40114 ?
              this.$t('static.productGroups.index.deleteHasProductError') :
              this.$t('static.productGroups.index.deleteError');
            this.$message({
              showClose: true,
              message,
              type: 'error',
            });
          });
      }).catch(() => {

      });
    },

    /**
     * Go to edit view for product group.
     *
     * @param  {Object} productGroup The product group object.
     */
    editProductGroup(productGroup) {
      this.$router.push({
        name: 'productGroups.edit',
        params: { id: productGroup.id },
      });
    },

    goToProducts(id, e) {
      e.stopPropagation();
      this.$router.push({ name: 'products.index', query: { filter: `productGroup,${id}` } });
    },
  },

  mixins: [
    SearchMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productGroups/index/index.js